export const CTA_URL = "https://fatalfans.com/julssynha";
export const INSTAGRAM_URL = "https://www.instagram.com/julssy__/";
export const TIKTOK_URL = "https://www.tiktok.com/@julssynhaofc";
export const HANDLE = "@julssy__";
export const TIKTOK_HANDLE = "@julssynhaofc";
export const BRAND = "JULSSY";

export const PHOTOS = {
  hero: "/img/hero.jpg",
  tile1: "/img/tile1.jpg",
  tile2: "/img/tile2.jpg",
  tile3: "/img/tile3.jpg",
  extra: "/img/extra.jpg",
};

export const TILES = [
  { src: PHOTOS.tile1, label: "Conteúdo Exclusivo" },
  { src: PHOTOS.tile2, label: "Fotos Premium" },
  { src: PHOTOS.tile3, label: "Intimidade Real" },
];
